import { FormBase } from 'core/components';

export default class SellerEdit3PLCredentialsForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				'sellerCredentials',
				'sellerCredentials[].warehouseName',
				'sellerCredentials[].customerId',
				'sellerCredentials[].clientId',
				'sellerCredentials[].clientSecret',
				'sellerCredentials[].vendorId',
				'sellerCredentials[].username',
				'sellerCredentials[].password',
			],
			labels: {
				'sellerCredentials[].warehouseName': 'SELLER3PLCREDENTIALS.WAREHOUSE',
				'sellerCredentials[].customerId': 'SELLER3PLCREDENTIALS.3PLSELLERID',
				'sellerCredentials[].clientId': 'SELLER3PLCREDENTIALS.3PLCLIENTID',
				'sellerCredentials[].clientSecret': 'SELLER3PLCREDENTIALS.3PLCLIENTSECRET',
				'sellerCredentials[].vendorId': 'SELLER3PLCREDENTIALS.VENDORID',
				'sellerCredentials[].username': 'SELLER3PLCREDENTIALS.USERNAME',
				'sellerCredentials[].password': 'SELLER3PLCREDENTIALS.PASSWORD',
			},
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/seller/forms/SellerEdit3PLCredentialsForm.js